import React, { Component } from 'react';
import { DatePicker as MUIDatePicker } from "@material-ui/pickers";
import ArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import ArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

class DatePicker extends Component {
  render() {
    const { value, onChange, format, ...rest } = this.props;
    return (
      <MUIDatePicker
        value={value}
        onChange={onChange}
        format={format? format : 'dd-MM-yyyy'}
        invalidlabel="Virhe"
        cancelLabel="Peruuta"
        clearLabel="Tyhjennä"
        todayLabel="Tänään"
        leftArrowIcon={<ArrowLeftIcon />}
        rightArrowIcon={<ArrowRightIcon />}
        minDate="2010-01-01"
        maxDate="2040-01-01"
        maxDateMessage="Päivämäärä liian pitkällä tulevaisudessa."
        minDateMessage="Päivämäärä liikaa mennessää ajassa."
        {...rest}
      />
    );
  }
}

export default DatePicker;
